/* famous-scale.js (pacote J3) — a vista "Scale" do hub Famous Paintings.

   Contrato: `snippets/famous-view-scale.liquid` imprime

     <div class="famous-scale" data-famous-scale hidden>
       <div class="famous-scale__head">
         <p data-famous-scale-readout></p><p data-famous-scale-total></p>
       </div>
       <div class="famous-scale__stage" data-famous-scale-stage role="region" tabindex="0">
         <div class="famous-scale__inner">
           <div data-famous-scale-rule></div>
           <div data-famous-scale-ref></div>
           <ol data-famous-scale-track></ol>
         </div>
       </div>
       <script type="application/json" data-famous-scale-data>[ … ]</script>
     </div>

   e cada entrada tem rank, title, artist, w, h, img, url, anchor. `w` e `h` em centímetros.

   Regras que este arquivo cumpre:
   - Uma escala só para todas as obras, tirada da mais alta da lista (ou da silhueta de 170 cm,
     se por acaso ela for a mais alta) para caber inteira na altura da faixa. Nada é ampliado
     nem encolhido para "ficar bonito".
   - A escala mora numa variável CSS única no contêiner. Redimensionar a janela reescreve UMA
     propriedade; os cem elementos se reposicionam sozinhos pelo calc() do CSS.
   - A caixa nasce com `hidden`. Ela só é revelada depois de o JSON ser lido e sobrar ao menos
     uma obra com w e h positivos. Sem JS, com a lista vazia, com JSON quebrado ou com medida
     inválida, não sobra buraco no layout nem erro no console.
   - Imagem só é pedida quando a obra chega perto da tela, e no tamanho em que foi desenhada.
     Obra com menos de 14 px de largura desenhada não pede imagem: naquele tamanho a imagem é
     um borrão e o retângulo diz a mesma coisa de graça.
   - Alvo de clique nunca abaixo de 24 px, foco visível, nada de animação.

   ATENÇÃO: nada de chave-porcento neste arquivo, nem dentro de comentário. O Shopify trata
   isso como Liquid e recusa o upload. */

(function () {
  'use strict';

  var REF_CM = 170; // altura da silhueta humana
  /* largura da silhueta em centímetros — de perfil, do bumbum à ponta do pé. Tem que bater com
     `--fs-ref-w` na folha e com o viewBox do <svg> que está no snippet: os três descrevem a mesma
     medida. Mudou no pacote K1, quando a silhueta deixou de ser de frente (46) e virou de perfil. */
  var REF_W_CM = 25.6;
  var MIN_IMG_PX = 8; // abaixo disso a obra fica sendo só o retângulo
  var LADDER = [64, 128, 200, 320, 480, 720, 1080, 1600, 2000];
  var RULE_STEPS_CM = [100, 200, 500, 1000];
  var MIN_STEP_PX = 26; // duas linhas de régua mais perto que isso viram sujeira

  /* A silhueta em si NÃO mora mais aqui: ela é um <svg> inline dentro do snippet
     famous-view-scale.liquid, num <path> só. Era um boneco montado com círculo e retângulos, que
     o Louie reprovou em 15/09/2026 por parecer placa de banheiro. Ficar no snippet mantém o
     desenho num lugar só, legível por quem abre o arquivo, e tira uma string de 1,6 kB do JS. */

  function toNum(v) {
    var n = typeof v === 'number' ? v : parseFloat(v);
    return isFinite(n) && n > 0 ? n : 0;
  }

  function txt(v) {
    return typeof v === 'string' ? v.trim() : '';
  }

  /* 79.4 -> "79.4", 349 -> "349". Sem casa decimal inútil. */
  function cm(v) {
    var r = Math.round(v * 10) / 10;
    return r % 1 === 0 ? String(Math.round(r)) : r.toFixed(1);
  }

  function inch(v) {
    return String(Math.round(v / 2.54));
  }

  /* só deixa passar destino que o navegador entende como link de verdade */
  function safeHref(u) {
    var s = txt(u);
    if (!s) return '';
    if (s.charAt(0) === '/' || s.charAt(0) === '#') return s;
    if (s.indexOf('//') === 0) return s;
    if (/^https?:\/\//i.test(s)) return s;
    return '';
  }

  function safeImg(u) {
    var s = txt(u);
    if (!s) return '';
    if (s.charAt(0) === '/' || s.indexOf('//') === 0 || /^https?:\/\//i.test(s)) return s;
    return '';
  }

  /* pede a imagem no degrau imediatamente acima do tamanho em que ela foi desenhada.
     Só mexe na URL quando ela é do CDN do Shopify, que entende o parâmetro width. */
  function sized(url, px) {
    var want = LADDER[LADDER.length - 1];
    for (var i = 0; i < LADDER.length; i++) {
      if (LADDER[i] >= px) {
        want = LADDER[i];
        break;
      }
    }
    var out = url;
    try {
      var u = new URL(url, window.location.href);
      if (u.hostname.indexOf('shopify.com') !== -1 || u.pathname.indexOf('/cdn/') === 0) {
        u.searchParams.set('width', String(want));
        out = u.toString();
      }
    } catch (e) {
      /* URL relativa esquisita: fica como veio */
    }
    return { url: out, px: want };
  }

  function el(tag, cls) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    return n;
  }

  function build(root) {
    /* Medido em 15/09/2026 no tema de dev: `increment` do Liquid recomeça do zero em CADA
       seção da página, então o guarda de "imprime o asset só uma vez" do snippet vale dentro
       de uma seção, não entre seções. Numa página que renderize a vista mais de uma vez, o
       <script> entra mais de uma vez e executa de novo. Sem esta trava, o segundo boot
       acrescentava outra cópia das cem obras na mesma faixa. */
    if (root.getAttribute('data-famous-scale-ready')) return;
    root.setAttribute('data-famous-scale-ready', '1');

    var dataEl = root.querySelector('[data-famous-scale-data]');
    var stage = root.querySelector('[data-famous-scale-stage]');
    var rule = root.querySelector('[data-famous-scale-rule]');
    var ref = root.querySelector('[data-famous-scale-ref]');
    var track = root.querySelector('[data-famous-scale-track]');
    var readout = root.querySelector('[data-famous-scale-readout]');
    var totalEl = root.querySelector('[data-famous-scale-total]');
    if (!dataEl || !stage || !rule || !ref || !track) return;

    var t0 = (window.performance && performance.now()) || 0;

    var list;
    try {
      list = JSON.parse(dataEl.textContent || '[]');
    } catch (e) {
      return; // JSON quebrado: a faixa continua escondida, sem buraco e sem erro
    }
    if (!Array.isArray(list) || !list.length) return;

    var works = [];
    var maxH = REF_CM;
    var sumW = 0;
    for (var i = 0; i < list.length; i++) {
      var it = list[i] || {};
      var w = toNum(it.w);
      var h = toNum(it.h);
      if (!w || !h) continue; // obra sem medida não entra nesta vista
      var anchor = txt(it.anchor);
      works.push({
        rank: toNum(it.rank) || 0,
        title: txt(it.title),
        artist: txt(it.artist),
        w: w,
        h: h,
        img: safeImg(it.img),
        href: safeHref(it.url) || (anchor ? '#' + anchor : '')
      });
      if (h > maxH) maxH = h;
      sumW += w;
    }
    if (!works.length) return;

    /* ------------------------------------------------------ coluna de referência */

    /* a silhueta já vem no HTML do snippet; o JS não redesenha nada, só confere que ela está lá */
    if (!ref.querySelector('[data-famous-scale-human]')) {
      var human = el('div', 'famous-scale__human');
      ref.appendChild(human);
    }

    var reflabel = el('div', 'famous-scale__reflabel');
    var refb = el('b');
    refb.textContent = REF_CM + ' cm';
    reflabel.appendChild(refb);
    reflabel.appendChild(document.createTextNode('5 ft 7 in'));
    ref.appendChild(reflabel);

    /* ------------------------------------------------------------------ as obras */

    var frag = document.createDocumentFragment();
    var items = [];
    for (var k = 0; k < works.length; k++) {
      var d = works[k];
      var li = el('li', 'famous-scale__item');
      li.style.setProperty('--w', String(d.w));
      li.style.setProperty('--h', String(d.h));

      var link = el(d.href ? 'a' : 'span', 'famous-scale__link');
      if (d.href) {
        link.setAttribute('href', d.href);
        link.setAttribute('aria-label', label(d));
      }

      var frame = el('span', 'famous-scale__frame');
      if (!d.img) {
        var blank = el('span', 'famous-scale__blank');
        var bnum = el('span', 'famous-scale__bnum');
        bnum.textContent = d.rank ? String(d.rank) : '';
        var btitle = el('span', 'famous-scale__btitle');
        btitle.textContent = d.title;
        blank.appendChild(bnum);
        blank.appendChild(btitle);
        frame.appendChild(blank);
      }
      link.appendChild(frame);
      li.appendChild(link);

      var cap = el('div', 'famous-scale__cap');
      var num = el('span', 'famous-scale__num');
      num.textContent = d.rank ? String(d.rank) : '';
      var ti = el('span', 'famous-scale__title');
      ti.textContent = d.title;
      var sz = el('span', 'famous-scale__size');
      sz.textContent = cm(d.w) + ' × ' + cm(d.h) + ' cm';
      cap.appendChild(num);
      cap.appendChild(ti);
      cap.appendChild(sz);
      li.appendChild(cap);

      li._fs = d;
      li._fsIndex = k;
      items.push(li);
      frag.appendChild(li);
    }
    var endMark = el('i', 'famous-scale__end');
    endMark.setAttribute('aria-hidden', 'true');
    frag.appendChild(endMark);
    track.appendChild(frag);

    function label(d) {
      var parts = [];
      if (d.rank) parts.push('Number ' + d.rank + '.');
      parts.push(d.title || 'Untitled');
      if (d.artist) parts.push('by ' + d.artist);
      parts.push(
        '— ' + cm(d.w) + ' by ' + cm(d.h) + ' centimetres, ' + inch(d.w) + ' by ' + inch(d.h) + ' inches.'
      );
      parts.push(d.href.charAt(0) === '#' ? 'Read the entry.' : 'See the reproduction.');
      return parts.join(' ');
    }

    /* --------------------------------------------------- revelar, medir, escalar */

    root.removeAttribute('hidden');
    root.style.setProperty('--fs-ref-w', String(REF_W_CM));

    var scale = 0;
    var step = 0;

    function applyScale() {
      var h = rule.getBoundingClientRect().height;
      if (!h) return false;
      var s = h / maxH;
      if (!isFinite(s) || s <= 0) return false;
      if (Math.abs(s - scale) < 0.0002) return false;
      scale = s;
      root.style.setProperty('--fs-px-cm', String(Math.round(s * 100000) / 100000));

      var want = RULE_STEPS_CM[RULE_STEPS_CM.length - 1];
      for (var i = 0; i < RULE_STEPS_CM.length; i++) {
        if (RULE_STEPS_CM[i] * s >= MIN_STEP_PX) {
          want = RULE_STEPS_CM[i];
          break;
        }
      }
      root.style.setProperty('--fs-m', (want * s).toFixed(3) + 'px');
      if (want !== step) {
        step = want;
        ticks(want);
      }
      return true;
    }

    var tickEls = [];
    function ticks(stepCm) {
      for (var i = 0; i < tickEls.length; i++) ref.removeChild(tickEls[i]);
      tickEls = [];
      for (var t = stepCm; t <= maxH; t += stepCm) {
        var s = el('span', 'famous-scale__tick');
        s.style.setProperty('--t', String(t));
        s.textContent = t / 100 + ' m';
        ref.appendChild(s);
        tickEls.push(s);
      }
    }

    applyScale();

    /* -------------------------------------------------------------- as imagens */

    var near = [];

    function loadImg(li) {
      var d = li._fs;
      if (!d.img || !scale) return;
      var drawn = d.w * scale;
      if (drawn < MIN_IMG_PX) return; // não vale um pedido de rede
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      var res = sized(d.img, Math.ceil(drawn * dpr));
      if (li._fsPx && li._fsPx >= res.px) return;
      li._fsPx = res.px;
      var img = li.querySelector('img');
      if (!img) {
        img = el('img', 'famous-scale__img');
        /* decorativa de propósito: o `aria-label` do link já diz obra, autor e medida.
           Sem `loading=lazy`: quem decide quando pedir é o IntersectionObserver daqui. O
           atributo só acrescentaria um segundo portão, com a régua do navegador, e dentro
           de um contêiner que rola na horizontal isso atrasava a imagem visivelmente. */
        img.alt = '';
        img.setAttribute('decoding', 'async');
        li.querySelector('.famous-scale__frame').appendChild(img);
      }
      img.src = res.url;
    }

    if (typeof IntersectionObserver === 'function') {
      var io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            var li = entries[i].target;
            var at = near.indexOf(li);
            if (entries[i].isIntersecting) {
              if (at === -1) near.push(li);
              loadImg(li);
            } else if (at !== -1) {
              near.splice(at, 1);
            }
          }
        },
        { root: stage, rootMargin: '0px 1200px 0px 1200px', threshold: 0 }
      );
      for (var a = 0; a < items.length; a++) if (items[a]._fs.img) io.observe(items[a]);
    } else {
      for (var b = 0; b < items.length && b < 40; b++) loadImg(items[b]);
    }

    /* ------------------------------------------------- a linha que diz quem é quem */

    var DEFAULT_READ = 'Same scale throughout. The figure is ' + REF_CM + ' cm (5 ft 7 in).';
    var hoverItem = null;
    var bandItem = null;
    var shown = null;

    function readLine() {
      if (!readout) return;
      var li = hoverItem || bandItem;
      if (li === shown) return;
      if (shown) shown.removeAttribute('data-read');
      shown = li;
      while (readout.firstChild) readout.removeChild(readout.firstChild);
      if (!li) {
        readout.appendChild(document.createTextNode(DEFAULT_READ));
        return;
      }
      li.setAttribute('data-read', '');
      var d = li._fs;
      var b = el('b');
      b.textContent = d.title || 'Untitled';
      readout.appendChild(b);
      var tail = '';
      if (d.artist) tail += ' · ' + d.artist;
      tail +=
        ' · ' +
        cm(d.w) +
        ' × ' +
        cm(d.h) +
        ' cm (' +
        inch(d.w) +
        ' × ' +
        inch(d.h) +
        ' in)';
      readout.appendChild(document.createTextNode(tail));
    }
    readLine();

    if (totalEl) {
      totalEl.textContent =
        works.length + (works.length === 1 ? ' painting · ' : ' paintings · ') +
        Math.round(sumW / 100) + ' m end to end';
    }

    function fromEvent(e) {
      var n = e.target;
      while (n && n !== track) {
        if (n._fs) return n;
        n = n.parentNode;
      }
      return null;
    }
    track.addEventListener('pointerover', function (e) {
      var li = fromEvent(e);
      if (li !== hoverItem) {
        hoverItem = li;
        readLine();
      }
    });
    track.addEventListener('pointerleave', function () {
      hoverItem = null;
      readLine();
    });
    track.addEventListener('focusin', function (e) {
      hoverItem = fromEvent(e);
      readLine();
    });
    track.addEventListener('focusout', function () {
      hoverItem = null;
      readLine();
    });

    /* a obra que está passando na frente vira a legenda enquanto se arrasta a faixa.
       É o que dá nome às obras pequenas no telefone, onde não existe hover. */
    if (typeof IntersectionObserver === 'function') {
      var band = [];
      var bandIo = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            var li = entries[i].target;
            var at = band.indexOf(li);
            if (entries[i].isIntersecting) {
              if (at === -1) band.push(li);
            } else if (at !== -1) {
              band.splice(at, 1);
            }
          }
          var pick = null;
          for (var j = 0; j < band.length; j++) {
            if (!pick || band[j]._fsIndex > pick._fsIndex) pick = band[j];
          }
          /* quando a janela de leitura cai bem no vão entre dois quadros ninguém intersecta.
             Nesse instante a legenda NÃO volta para o texto padrão: ela segura a última obra,
             senão o texto pisca a cada quadro que passa. Medido: com o vão de 24px e uma
             janela estreita, isso acontecia o tempo todo. */
          if (pick) {
            bandItem = pick;
            readLine();
          }
        },
        { root: stage, rootMargin: '0px -62% 0px -20%', threshold: 0 }
      );
      for (var c = 0; c < items.length; c++) bandIo.observe(items[c]);
    }

    /* o esmaecimento da borda direita some quando a marca de fim entra em tela. Um observador
       em vez de um ouvinte de scroll: nada roda a cada pixel arrastado. */
    if (typeof IntersectionObserver === 'function') {
      new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) root.setAttribute('data-end', '');
            else root.removeAttribute('data-end');
          }
        },
        { root: stage, threshold: 0 }
      ).observe(endMark);
    }

    /* ---------------------------------------------------------------- redimensão */

    var queued = false;
    function onResize() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        if (applyScale()) for (var i = 0; i < near.length; i++) loadImg(near[i]);
      });
    }
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(onResize).observe(stage);
    } else {
      window.addEventListener('resize', onResize);
    }

    var t1 = (window.performance && performance.now()) || 0;
    (window.famousScaleMetrics = window.famousScaleMetrics || []).push({
      count: works.length,
      dropped: list.length - works.length,
      nodes: root.querySelectorAll('*').length,
      maxHeightCm: maxH,
      pxPerCm: Math.round(scale * 100000) / 100000,
      ruleStepCm: step,
      buildMs: Math.round((t1 - t0) * 10) / 10
    });
  }

  function boot() {
    var all = document.querySelectorAll('[data-famous-scale]');
    for (var i = 0; i < all.length; i++) build(all[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
